import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Wniosek',
  type: 'object',
  properties: {
    application: {
      type: 'object',
      title: 'Wniosek',
      properties: {
        type: {
          type: 'string',
          default: 'NEW'
        },
        firstName: {
          title: 'Imię *',
          type: 'string',
          fieldRequired: true
        },
        lastName: {
          title: 'Nazwisko *',
          type: 'string',
          fieldRequired: true
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          fieldRequired: false
        },
        phoneNumber: {
          title: 'Numer telefonu (opcjonalne)',
          type: 'string',
          fieldRequired: false
        },
        birthDate: {
          title: 'Data urodzenia *',
          type: 'string',
          format: 'date',
          fieldRequired: true
        },
        woj: {
          title: 'Województwo *',
          type: 'string',
          fieldRequired: true
        },
        pow: {
          title: 'Powiat *',
          type: 'string',
          fieldRequired: true
        },
        gmi: {
          title: 'Gmina *',
          type: 'string',
          fieldRequired: true
        },
        terc: {
          title: 'Kod TERC',
          type: 'string',
          fieldRequired: true,
          minLength: 6
        },
        city: {
          title: 'Miejscowość *',
          type: 'string',
          fieldRequired: true
        },
        simc: {
          title: 'Kod SIMC',
          type: 'string',
          fieldRequired: true
        },
        street: {
          title: 'Ulica *',
          type: 'string',
          fieldRequired: true
        },
        ulic: {
          title: 'Kod ULIC',
          type: 'string',
          fieldRequired: false
        },
        postalCode: {
          title: 'Kod pocztowy *',
          type: 'string',
          format: 'kod',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny kod pocztowy'
          }
        },
        homeNumber: {
          title: 'Numer budynku *',
          type: 'string',
          fieldRequired: true
        },
        localNumber: {
          title: 'Numer lokalu',
          type: 'string',
          fieldRequired: false
        },
        profileId: {
          type: 'number',
          fieldRequired: true
        },
        collectionPointId: {
          title: 'Punkt odbioru *',
          type: 'number',
          fieldRequired: true
        },
        date: {
          title: 'Data złożenia wniosku',
          type: 'string',
          format: 'date',
          fieldRequired: true
        },
        physical: {
          title: 'Chcę kartę fizyczną',
          type: 'boolean',
          default: true,
          fieldRequired: false
        },
        style: {
          title: 'Wygląd karty',
          type: 'string',
          fieldRequired: false
        },
        groups: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              groupId: {
                type: 'number'
              }
            }
          }
        }
      }
    }
  }
};
